<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticLoadBalancingResourceListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticLoadBalancingResourceVue = {};
export default {
  name: "TableElasticLoadBalancingResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      subjectSearchKey: "",
      priorityId: "",
      columns: [
        {
          title: this.$t("RAM.AWS.ElasticLoadBalancer.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.ElasticLoadBalancer.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.ElasticLoadBalancer.ELBName"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.ElasticLoadBalancer.DNSName"),
          key: "dnsName"
        },
        {
          title: this.$t("RAM.AWS.ElasticLoadBalancer.availabilityZone"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.ElasticLoadBalancer.instanceID"),
          key: "loadbalancerId"
        },
        {
          title: "VPC ID",
          key: "vpcId"
        },
        {
          title: this.$t("RAM.AWS.ElasticLoadBalancer.targetCluster"),
          key: "loadBalancerArn"
        },
        {
          title: this.$t("RAM.AWS.ElasticLoadBalancer.securityGroup"),
          key: "securityGroups"
        }
      ],
      tableElasticLoadBalancingResourceListData: []
    };
  },
  beforeCreate: function() {
    tableElasticLoadBalancingResourceVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableElasticLoadBalancingResourceVue.companyId = val;
    });
    eventBus.$on("loadBalancerName", function(val) {
      tableElasticLoadBalancingResourceVue.loadBalancerName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticLoadBalancingResourceVue.getElasticLoadBalancingResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticLoadBalancingResourceListData: function() {
      this.$api.resourceManagement
        .selectAWSLoadBalancerByPage({
          companyId: this.companyId,
          loadBalancerName: this.loadBalancerName,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableElasticLoadBalancingResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticLoadBalancingResourceVue.getElasticLoadBalancingResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticLoadBalancingResourceVue.getElasticLoadBalancingResourceListData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/elb/TableElasticLoadBalancingResource.vue